export enum SearchAwardFilterValue {
  IOTD = "iotd",
  TOP_PICK = "top-pick",
  TOP_PICK_NOMINATION = "top-pick-nomination"
}
